<template>
	<v-card>
		<v-card-title>
			<h1>Tulip Assist Dashboard</h1>
		</v-card-title>
		<v-card-text>
			<p><translate>Welcome to the backoffice of</translate> Tulip Assist</p>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'BackOfficeHome'
};
</script>
